var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 1.85107H10.2168C10.6051 1.85107 10.9199 1.53629 10.9199 1.14795C10.9199 0.759613 10.6051 0.444824 10.2168 0.444824H5.99805C5.60971 0.444824 5.29492 0.759613 5.29492 1.14795C5.29492 1.53629 5.60971 1.85107 5.99805 1.85107Z",
    fill: "#677C95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10742 2.97607C3.83228 2.97607 0.373047 6.43591 0.373047 10.7104C0.373047 14.9855 3.83277 18.4448 8.10742 18.4448C12.3826 18.4448 15.8418 14.985 15.8418 10.7104C15.8418 6.43531 12.382 2.97607 8.10742 2.97607ZM8.10742 17.0386C4.61809 17.0386 1.7793 14.1998 1.7793 10.7104C1.7793 7.22112 4.61809 4.38232 8.10742 4.38232C11.5968 4.38232 14.4355 7.22112 14.4355 10.7104C14.4355 14.1998 11.5968 17.0386 8.10742 17.0386Z",
    fill: "#677C95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10742 6.4917C7.71909 6.4917 7.4043 6.80649 7.4043 7.19482V10.7104C7.4043 11.0988 7.71909 11.4136 8.10742 11.4136C8.49576 11.4136 8.81055 11.0988 8.81055 10.7104V7.19482C8.81055 6.80649 8.49576 6.4917 8.10742 6.4917Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.6905863e1a86bc78ccfce1cc93687a05.svg";
export { ForwardRef as ReactComponent };